module.exports = __webpack_public_path__ + "img/sec2_21.b6de36be.png";